// Import the configured Store environment
import { GetAppConfig } from "global/config/AppConfigStore";



// Return the prefix and suffix that surround a Store alias
export const GetStoreUrlParts = () => {

    // Read the current Store URL configuration
    const config = GetAppConfig();
    const storeBaseUrl = config.storeUrl.replace(/\/+$/, "");

    // Use subdomains for live Stores
    if (config.storeUrlFormat === "subdomain") {
        const storeAddress = new URL(storeBaseUrl);
        return { prefix: `${storeAddress.protocol}//`, suffix: `.${storeAddress.host}` };
    }

    // Keep path-based Store URLs for test
    return { prefix: `${storeBaseUrl}/`, suffix: "" };

};



// Build a customer Store URL with an optional page path
export const GetStoreUrl = (alias, path = "") => {

    // Retrieve the configured URL format
    const { prefix, suffix } = GetStoreUrlParts();

    // Add the requested page path when supplied
    const pagePath = path ? `/${path.replace(/^\/+/, "")}` : "";

    // Return the complete Store URL
    return `${prefix}${alias}${suffix}${pagePath}`;

};



// Build a public Etsy shop URL from the shop name supplied by Etsy
export const GetEtsyShopUrl = (shopName) => {

    return `https://www.etsy.com/shop/${encodeURIComponent(shopName)}`;

};



// Build a marketplace URL without using a customer subdomain
export const GetMarketplaceUrl = (path = "") => {

    // Read the configured Store base URL
    const config = GetAppConfig();
    const storeBaseUrl = config.storeUrl.replace(/\/+$/, "");

    // Add the requested marketplace page path
    const pagePath = path ? `/${path.replace(/^\/+/, "")}` : "";

    // Keep the original marketplace path in development
    if (config.storeUrlFormat === "path") {
        return `${storeBaseUrl}/marketplace${pagePath}`;
    }

    // Live marketplace pages are served directly from the root domain
    return `${storeBaseUrl}${pagePath}`;

};